<template>
  <div class="array-summary-cell-renderer">
    <div v-if="hasValue" class="d-flex justify-content-between align-items-center gap-1">
      <GuBadge
        variant="info"
        pill
        :class="params.badgePosition === 'right' && 'order-1'"
      >
        {{ length }}
      </GuBadge>
      {{ truncatedString }}
    </div>
    <i v-else>None</i>
  </div>
</template>

<script setup>
import { computed, ref, toRefs } from 'vue'
import { GuBadge } from '@shared/gu-components/badge'
import { sortFunc } from '@shared/utils/sort'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const defaultMaxLength = ref(3)

const hasValue = computed(() => {
  return params.value.value && params.value.value.length > 0
})

const length = computed(() => {
  return params.value.value.length
})

const truncatedString = computed(() => {
  const { value, key, maxLength } = params.value
  const array = value.map(item => item[key]).sort(sortFunc)
  const finalMaxLength = maxLength || defaultMaxLength.value
  const truncatedString = array.slice(0, finalMaxLength).join(', ')
  return array.length > finalMaxLength ? `${truncatedString}...` : truncatedString
  })
</script>
